export * from './generated';
export var BoostpointCreateAiEnvironment;
(function (BoostpointCreateAiEnvironment) {
    BoostpointCreateAiEnvironment["Development"] = "http://127.0.0.1:6001";
    BoostpointCreateAiEnvironment["Production"] = "https://api.boostpointcreate.ai";
    BoostpointCreateAiEnvironment["Staging"] = "https://api-staging.boostpointcreate.ai";
})(BoostpointCreateAiEnvironment || (BoostpointCreateAiEnvironment = {}));
